import { SupportedLocaleEnum } from '@reward-platform/shared-schemas'
import { createPathname } from '@reward-platform/utils'
import { usePartner } from './PartnerContext'

const INTERNAL_PATH_REGEX = /^\/([a-zA-Z0-9\-._~:@%&?=/]*)$/

type RouteFunctions = {
  /**
   * uses basePath from platform context to conditionally create pathname used for routing
   */
  createRoutePath(pathname: string, locale?: string): string
}

/**
 * Hook to determine application routes depending on platform base path
 * used for routing in avios.com
 */
export const usePlatformRoutes = (): RouteFunctions => {
  const { basePath } = usePartner()

  const createRoutePath: RouteFunctions['createRoutePath'] = (pathname, locale) => {
    const isInternalPath = INTERNAL_PATH_REGEX.test(pathname)
    if (!!pathname && !isInternalPath) {
      return pathname
    }
    const localeParse = SupportedLocaleEnum.safeParse(locale)
    if (localeParse.success) {
      return createPathname(pathname, basePath, locale)
    }
    return createPathname(pathname, basePath)
  }

  return { createRoutePath }
}

export default usePlatformRoutes
